<div class="cmn-dialog-card-view mesh-gradient">
    <button class="dialog-close-btn" (click)="closeDialog()">
        <img class="cross-icon" src="assets/svg/icons/cross.svg" />
    </button>
    <div class="dialog-header">
        <span class="icon dialog-header-icon" svgIcon="assets/svg/icons/edit-receipt-gb.svg"></span>
        <h1 class="dialog-header-title">Confirm Your Payment</h1>
    </div>
    <mat-dialog-content>
        <div class="dialog-body">
            <h2 class="fs-3xl">
                {{ summaryDetails?.totalPayable | defaultBlank: "number" : { symbol: "₹", position: "before" } }}
            </h2>
            <p
                class="fs-md text-primary-30"
                *ngIf="
                    summaryDetails?.repaymentOption != repaymentOption.FORECLOSE &&
                    summaryDetails?.repaymentOption != repaymentOption.CUSTOM
                "
            >
                You’re about to pay {{ summaryDetails?.label }}
            </p>
            <p class="fs-md text-primary-30" *ngIf="summaryDetails?.repaymentOption == repaymentOption.FORECLOSE">
                You’re about to foreclose your Klinq loan.
            </p>
            <p class="fs-md text-primary-30" *ngIf="summaryDetails?.repaymentOption == repaymentOption.CUSTOM">
                You’re about to pay a custom amount.
            </p>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="dialog-actions">
            <div class="dialog-actions-btn">
                <button type="submit" class="primary-fill-btn btn-w100" (click)="proceed()">Confirm</button>
                <button class="primary-outline-btn btn-w100" (click)="closeDialog()">Cancel</button>
            </div>
        </div>
    </mat-dialog-actions>
</div>
